import $ from 'jquery'
import { RANGE_SP } from '@namespace/common/rangeSp'
import { UA_TABLET } from '@namespace/common/uaTablet'
import { UA_CLASS } from '@namespace/common/uaClass'
import { GNAV } from '@namespace/common/gnav'
// import { LOCATION_CHECK } from '@namespace/common/locationCheck'
import { SMOOTH_SCROLL } from '@namespace/common/smoothScroll'
import { SCROLL_TOP } from '@namespace/common/scrollTop'
// import { TAB } from '@namespace/common/tab'
// import { ACCORDION } from '@namespace/common/accordion'
// import { SEPARATE_WITH_SPAN } from '@namespace/common/separateWithSpan'
// import { GALLERY_LIGHTBOX } from '@namespace/common/galleryLightbox'

export default function common() {
  const GLOBALSITE = {
    COMMON: {
      VARIABLES: {
        range_sp: true,
      },
      init: function () {
        this.RANGE_SP.init(this.VARIABLES)
        this.UA_TABLET.init()
        this.UA_CLASS.init()
        this.GNAV.init(GLOBALSITE)
        // this.LOCATION_CHECK.init('gallery', 'year')
        this.SMOOTH_SCROLL.init()
        this.SCROLL_TOP.init()
        // this.TAB.init()
        // this.ACCORDION.init()
        // this.SEPARATE_WITH_SPAN.init()
        // this.GALLERY_LIGHTBOX.init('[id^="gallery"]')
        // this.GALLERY_LIGHTBOX.init('.wp-block-gallery > .wp-block-image')
      },
      RANGE_SP,
      UA_TABLET,
      UA_CLASS,
      GNAV,
      // LOCATION_CHECK,
      SMOOTH_SCROLL,
      SCROLL_TOP,
      // TAB,
      // ACCORDION,
      // SEPARATE_WITH_SPAN,
      // GALLERY_LIGHTBOX,
    },
  }

  $(function () {
    GLOBALSITE.COMMON.init()
  })
  $(window).on('load', function () {
    $('body').addClass('initialized')
  })
}
